import 'Src/less/automotive/service-center-landing-page.less';
import AutomotiveServiceCenterStoreInfo from '../shared/components/AutomotiveServiceCenterStoreInfo.vue';
import globalData from 'Src/js/global/window-data';
import Vue from 'vue';
import { BlogCategories } from 'Src/js/services/BlogService';
import { initializeAsyncBlogCarousel } from 'Src/js/utilities/blog';
import { lazyLoadImages } from 'Src/js/global/images';

const storeInfoRoot = document.querySelector('.asclp-store-vue');
if (storeInfoRoot) {
	new Vue({
		el: storeInfoRoot,
		render: h => h(AutomotiveServiceCenterStoreInfo, {
			props: {
				store: globalData.localStore,
			}
		})
	});
}

initializeAsyncBlogCarousel('#asclpBlogCarousel', {
	heading: 'Auto Care Tips & Advice',
	query: {
		categories: [BlogCategories.Automotive],
		perPage: 12,
		tags: []
	},

});

lazyLoadImages(document.querySelector('#asclp') as HTMLElement);